module.exports = __webpack_public_path__ + "static/media/instruct3.2fe6086c.png";